import React, { useState } from 'react';

interface ConversationAvatarProps {
  author: string;
  isAdmin: boolean;
  profileImage?: string;
}

// Utility function to generate initials from name
const generateInitials = (name: string) => {
  if (!name) return 'U'; // Default: User

  const words = name.trim().split(' ');
  if (words.length >= 2) {
    return `${words[0].charAt(0).toUpperCase()}${words[1].charAt(0).toUpperCase()}`;
  } else if (words.length === 1) {
    return words[0].substring(0, 1).toUpperCase();
  }
  return 'U';
};

const ConversationAvatar: React.FC<ConversationAvatarProps> = ({
  author,
  isAdmin,
  profileImage
}) => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  // Show initials if no profile image or if image failed to load
  if (!profileImage || imageError) {
    const initials = generateInitials(author);
    const backgroundColor = isAdmin ? '#3957A0' : '#D7A360';

    return (
      <div
        className="conversation-avatar"
        style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          backgroundColor,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '14px',
        }}
        title={author}
      >
        {initials}
      </div>
    );
  }

  // Show profile image
  return (
    <img
      src={profileImage}
      alt={author}
      className="conversation-avatar"
      style={{
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        objectFit: 'cover',
      }}
      onError={handleImageError}
      title={author}
    />
  );
};

export default ConversationAvatar;